import React from 'react'
import { connect } from 'react-redux'
import Moment from 'react-moment'
import { getFormValues } from 'redux-form'
import {
  Fade,
} from '@material-ui/core'
import { 
  Divider,
  Button
} from 'semantic-ui-react'
import { FileRow } from './FileRow'
import FieldAttachment from './FieldAttachment'
import { StdCard } from 'components'
import { selectAttachmentGroup } from '../../AttributeData'

import { ProcurementBody } from '../../../styled'
import { AttachmentInfoContainer } from './styled'
import { AttachmentContainer2, Cont2, SContDetail, AttachmentGroup, AttachmentContent } from './styled'
import r from 'reactotron-react-js'


const Attachment = props => {
  const { 
    //props
    isCreate, 
    isEdit, 
    change,
    requireMemo=false,
    //state 
    grDetail,
    valueForm,
    vendorCode
  } = props

  var commentAttachments = valueForm&&valueForm.goodsServiceReceiptAttachments?valueForm.goodsServiceReceiptAttachments.filter(x=>x.documentCode==="GR01"):[]

  if(valueForm){
    var documentTypesFilter = selectAttachmentGroup(valueForm.mainDeliveryType,valueForm.subDeliveryType,props.grType.data, vendorCode)
  }
  function setAttachment() {
    if (documentTypesFilter) {
      let file = []
      documentTypesFilter.forEach((item, i) => {
        if(valueForm.isFromVendor?item.code.toLowerCase()!='gr04':true){
          file.push({
            code: item.code,
            title: item.name,
            items: valueForm.goodsServiceReceiptAttachments.filter(
              item2 => item2.documentCode === item.code
            ),
          })
        }
      })
      return file.map((item, i) => {
        return <FileRow attachmentTitle={item.title} files={item.items} />
      })
    } else {
      return null
    }
  }

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        {/* <StdCard title="Attachment"> */}
        <StdCard title={<span style={{fontSize:'1.2rem'}}>Attachment <span style={{marginLeft:'1rem', fontSize:'1.5rem', color:'#FBBF66'}}>{(vendorCode&&(vendorCode.startsWith('9')||vendorCode.startsWith('6'))&&valueForm.mainDeliveryType.toLowerCase()=='service')?'Vendor บริษัทในเครือกลุ่มบริษัทดีทีจีโอ ไม่ต้องมีใบแจ้งหนี้ในขั้นตอนการตรวจรับงาน':''}</span></span>}>
          <div style={{ color: 'orange' }}>
            <span>ผู้ส่งมอบ (Vendor) สามารถแนบเอกสารผลงานต่างๆในระบบ EzProcure โดยไม่จำเป็นต้องส่งเอกสารตัวจริงมาให้ทางกลุ่มบริษัทดีทีจีโอ</span><br />
            <span>Vendors can attach delivery documents in EzProcure without needing to submit original documents to DTGO.</span>
          </div>
          {(isCreate||isEdit) ? (
            <FieldAttachment requireMemo={requireMemo}/>
          ) : (
            <AttachmentInfoContainer>
              {grDetail.loaded&&setAttachment()}
            </AttachmentInfoContainer>
          )}
          <br/>
          <div>
            <span>หมายเหตุ / Note: </span>
            <ul style={{marginTop:'0.3rem'}}>
              <li>รองรับได้สูงสุด 250 MB ต่อไฟล์ / The maximum file size is 250 MB (per file).</li>
              <li>ความเร็วและข้อผิดพลาดในการอัพโหลด/ดาวน์โหลดไฟล์ขนาดใหญ่ ขึ้นอยู่กับอินเตอร์เน็ตที่ท่านใช้งาน / The speed and error in uploading or downloading depend on your internet connection.</li>
            </ul>
          </div>
        </StdCard>
        {
          commentAttachments.length ? 
            <StdCard title='Attachments (from comment)' style={{ marginTop: '15px' }} >
              <AttachmentContainer2>
                <Cont2>
                  {
                    valueForm.goodsServiceReceiptComments.map(a => {
                      let files = commentAttachments.filter(x=>x.commentId===a.id)
                      if(files.length){
                        return(
                          <AttachmentGroup>
                            <div className='attachmentBy'>
                              <span>{a.createdByName}</span>
                              <Moment format='DD MMM YYYY hh:mm'>{a.createdDate}</Moment>
                            </div>
                            <AttachmentContent>
                              {
                                files.map((f,i) => 
                                  <SContDetail style={i==0?{ marginTop: '0px' }:null}>
                                    {/* <Button style={{flex:1,display:'flex',justifyContent:'flex-start'}} type='button' content={<div className='fileName'>{f.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.open(f.urlPath,"_blank"))}/> */}
                                    <Button style={{flex:1,display:'flex',justifyContent:'flex-start'}} type='button' content={<div className='fileName'>{f.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.location.href = f.urlPath)}/>
                                  </SContDetail>
                                )
                              }
                              <Divider/>
                            </AttachmentContent>
                          </AttachmentGroup>
                        )
                      }else{
                        return null
                      }
                      
                    })
                  }
                </Cont2>
              </AttachmentContainer2>
            </StdCard> : null
        }
      </ProcurementBody>
    </Fade>
  )
  
}
const mapStateToProps = (state, props) => {
  let valueForm = getFormValues('formGR')(state)
  let vendorCode = valueForm?valueForm.vendorCode:0
  if(!vendorCode){
    vendorCode = valueForm.goodsServiceReceiptPOs[0]?valueForm.goodsServiceReceiptPOs[0].vendorCode:0
  }
  return {
    grDetail: state.gr.grDetail,
    grType: state.gr.grType,
    valueForm: valueForm,
    vendorCode : vendorCode
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Attachment)
